module.exports = __webpack_public_path__ + "static/media/CLA_CSV_5.d90b658a.svg";